import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosTimeAgoComponent } from './pos-time-ago.component';

@NgModule({
  declarations: [PosTimeAgoComponent],
  imports: [CommonModule],
  exports: [PosTimeAgoComponent],
})
export class PosTimeAgoModule {}
